import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsPostMunicipalities_municipalityIdBuildings_buildingIdImage = z.any()
export type TagsPostMunicipalities_municipalityIdBuildings_buildingIdImage = z.infer<typeof tagsPostMunicipalities_municipalityIdBuildings_buildingIdImage>

export const consumesPostMunicipalities_municipalityIdBuildings_buildingIdImage = z.any()
export type ConsumesPostMunicipalities_municipalityIdBuildings_buildingIdImage = z.infer<typeof consumesPostMunicipalities_municipalityIdBuildings_buildingIdImage>

export const paramsPostMunicipalities_municipalityIdBuildings_buildingIdImage = z.object({ "municipalityId": z.string(), "buildingId": z.string() })
export type ParamsPostMunicipalities_municipalityIdBuildings_buildingIdImage = z.infer<typeof paramsPostMunicipalities_municipalityIdBuildings_buildingIdImage>

export const bodyPostMunicipalities_municipalityIdBuildings_buildingIdImage = z.object({ "image": z.object({ "encoding": z.string(), "filename": z.string(), "mimetype": z.string(), "file": z.any(), "type": z.string().optional() }) })
export type BodyPostMunicipalities_municipalityIdBuildings_buildingIdImage = z.infer<typeof bodyPostMunicipalities_municipalityIdBuildings_buildingIdImage>

export const responsePostMunicipalities_municipalityIdBuildings_buildingIdImage = z.object({ "payload": z.object({ "id": z.string(), "image": z.string() }).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponsePostMunicipalities_municipalityIdBuildings_buildingIdImage = z.infer<typeof responsePostMunicipalities_municipalityIdBuildings_buildingIdImage>

interface IPostMunicipalities_municipalityIdBuildings_buildingIdImage extends BaseMethodType {
  tags: TagsPostMunicipalities_municipalityIdBuildings_buildingIdImage,
  consumes: ConsumesPostMunicipalities_municipalityIdBuildings_buildingIdImage,
  params: ParamsPostMunicipalities_municipalityIdBuildings_buildingIdImage,
  body: BodyPostMunicipalities_municipalityIdBuildings_buildingIdImage,
  response: ResponsePostMunicipalities_municipalityIdBuildings_buildingIdImage
}
export const tagsGetMunicipalities_municipalityIdBuildings_buildingIdImage = z.any()
export type TagsGetMunicipalities_municipalityIdBuildings_buildingIdImage = z.infer<typeof tagsGetMunicipalities_municipalityIdBuildings_buildingIdImage>

export const paramsGetMunicipalities_municipalityIdBuildings_buildingIdImage = z.object({ "municipalityId": z.string(), "buildingId": z.string() })
export type ParamsGetMunicipalities_municipalityIdBuildings_buildingIdImage = z.infer<typeof paramsGetMunicipalities_municipalityIdBuildings_buildingIdImage>

export const responseGetMunicipalities_municipalityIdBuildings_buildingIdImage = z.any()
export type ResponseGetMunicipalities_municipalityIdBuildings_buildingIdImage = z.infer<typeof responseGetMunicipalities_municipalityIdBuildings_buildingIdImage>

interface IGetMunicipalities_municipalityIdBuildings_buildingIdImage extends BaseMethodType {
  tags: TagsGetMunicipalities_municipalityIdBuildings_buildingIdImage,
  params: ParamsGetMunicipalities_municipalityIdBuildings_buildingIdImage,
  response: ResponseGetMunicipalities_municipalityIdBuildings_buildingIdImage
}
export const URL = '/municipalities/:municipalityId/buildings/:buildingId/image'
export const validation = {
  post: {
    tags: tagsPostMunicipalities_municipalityIdBuildings_buildingIdImage,
    consumes: consumesPostMunicipalities_municipalityIdBuildings_buildingIdImage,
    params: paramsPostMunicipalities_municipalityIdBuildings_buildingIdImage,
    body: bodyPostMunicipalities_municipalityIdBuildings_buildingIdImage,
    response: responsePostMunicipalities_municipalityIdBuildings_buildingIdImage
  },
  get: {
    tags: tagsGetMunicipalities_municipalityIdBuildings_buildingIdImage,
    params: paramsGetMunicipalities_municipalityIdBuildings_buildingIdImage,
    response: responseGetMunicipalities_municipalityIdBuildings_buildingIdImage
  }
}
export interface Municipalities_municipalityIdBuildings_buildingIdImage extends BaseRouteType {
  post: IPostMunicipalities_municipalityIdBuildings_buildingIdImage,
  get: IGetMunicipalities_municipalityIdBuildings_buildingIdImage
}